export const TICKET_LIST_REQUEST = "TICKET_LIST_REQUEST";
export const TICKET_LIST_SUCCESS = "TICKET_LIST_SUCCESS";
export const TICKET_LIST_FAIL = "TICKET_LIST_FAIL";

export const TICKET_EDIT_REQUEST = "TICKET_EDIT_REQUEST";
export const TICKET_EDIT_SUCCESS = "TICKET_EDIT_SUCCESS";
export const TICKET_EDIT_FAIL = "TICKET_EDIT_FAIL";

export const TICKET_DELETE_REQUEST = "TICKET_DELETE_REQUEST";
export const TICKET_DELETE_SUCCESS = "TICKET_DELETE_SUCCESS";
export const TICKET_DELETE_FAIL = "TICKET_DELETE_FAIL";

export const TICKET_CREATE_REQUEST = "TICKET_CREATE_REQUEST";
export const TICKET_CREATE_SUCCESS = "TICKET_CREATE_SUCCESS";
export const TICKET_CREATE_FAIL = "TICKET_CREATE_FAIL";
export const TICKET_CREATE_RESET = "TICKET_CREATE_RESET";

export const TICKET_UPDATE_REQUEST = "TICKET_UPDATE_REQUEST";
export const TICKET_UPDATE_SUCCESS = "TICKET_UPDATE_SUCCESS";
export const TICKET_UPDATE_FAIL = "TICKET_UPDATE_FAIL";
export const TICKET_UPDATE_RESET = "TICKET_UPDATE_RESET";